import React, { useEffect, useState } from "react";

import { useForm, Form } from "../useForm";

import Input from "../controls/Input";

import { makeApiCall } from "../../shared/makeApiCall";

const initialFValues = {
  name: "",
  email: "",
  storeName: "",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SettingsProfileForm(props) {
  const {
    checkRequestError,
    onUpdateUserProfile,
    profile,
    setErrorModalOpen,
    setShow,
    userId,
    userType,
  } = props;

  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const updateProfile = async function () {
    setDisableSubmitButton(true);
    const authData = {
      action: "updateProfile",
      userId: userId,
      data: values,
      userType: userType,
    };
    let callResult = await makeApiCall(authData);
    setDisableSubmitButton(false);
    if (callResult.success) {
      onUpdateUserProfile(values);
      setShow({ show: true, title: "Profile updated." });
    } else {
      const isLogout = checkRequestError(callResult.errorStatus);
      if (!isLogout) {
        setErrorModalOpen({
          open: true,
          title: "Sorry!",
          subtitle: callResult.data.subtitle,
        });
      }
      setSubmitError(callResult.data.subtitle);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      updateProfile();
    }
  };

  useEffect(() => {
    setValues(profile);
  }, [profile]);

  return (
    <>
      <div>
        <div className="md:grid md:grid-cols-3 md:gap-6">
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Profile
              </h3>
            </div>
          </div>
          <div className="mt-5 md:col-span-2 md:mt-0">
            <Form onSubmit={handleSubmit}>
              <div className="shadow sm:overflow-hidden sm:rounded-md">
                <div className="space-y-6 bg-white px-4 py-5 sm:p-6">
                  <div className="grid grid-cols-3 gap-6">
                    <div className="col-span-3 sm:col-span-2">
                      <Input
                        label="Name"
                        name="name"
                        onChange={handleInputChange}
                        value={values.name}
                        labelOn={true}
                      />
                    </div>
                    <div className="col-span-3 sm:col-span-2">
                      <Input
                        label="Email"
                        name="email"
                        onChange={handleInputChange}
                        value={values.email}
                        labelOn={true}
                      />
                    </div>
                    <div
                      className={classNames(
                        userType === "1" ? "hidden" : "",
                        "col-span-3 sm:col-span-2"
                      )}
                    >
                      <Input
                        label="Store Name"
                        name="storeName"
                        onChange={handleInputChange}
                        value={values.storeName}
                        labelOn={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
                  <button
                    type="submit"
                    className="ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                    disabled={disableSubmitButton}
                  >
                    {disableSubmitButton ? (
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}
